import React from "react";
import { CircleAlert, Info, Lock, ShieldCheck, Monitor, Wifi, CircleCheckBig } from "lucide-react";
import ContentsContainer from "../../components/ContentsContainer";

const sections = [
 {
    sectionId: "about",
    sectionTitle: "1. About This Policy",
    searchKeywords: `
        Hyvid fully remote company work from home telecommuting RA 11165 
        DOLE 237 RA 10173 handle data technology separate concerns same 
        picture policy covers three interconnected areas structured
        expected personal handled client protected systems Republic
    `,
    sectionBody: (
      <div className="space-y-4 text-sm  leading-relaxed">
        <p>Hyvid is a fully remote company. That means how we work from home, how we handle data, and how we use technology aren't separate concerns — they're all part of the same picture.</p>

        <p>This policy covers three interconnected areas:</p>

        <ul className="list-none space-y-1.5 pl-2">
          <li className="flex items-start gap-2">
            <span className="mt-1.5 w-1.5 h-1.5 rounded-full bg-emerald-400 flex-shrink-0" />
            <span>How remote work is structured and what's expected of you.</span>
          </li>
          <li className="flex items-start gap-2">
            <span className="mt-1.5 w-1.5 h-1.5 rounded-full bg-emerald-400 flex-shrink-0" />
            <span>How personal and client data must be handled and protected.</span>
          </li>
          <li className="flex items-start gap-2">
            <span className="mt-1.5 w-1.5 h-1.5 rounded-full bg-emerald-400 flex-shrink-0" />
            <span>How Hyvid's technology and systems may and may not be used.</span>
          </li>
        </ul>

        <p>This policy complies with the Telecommuting Act (Republic Act No. 11165), DOLE Department Order No. 237-22, and the Data Privacy Act of 2012 (Republic Act No. 10173).</p>
      </div>
    ),
  },

  {
    sectionId: "wfh",
    sectionTitle: "2. Work-from-Home Arrangements",
    searchKeywords: `
      Hyvid Philippines employees work remotely default specific  
      location agreed alternative confirmed employment agreement hours  
      equipment laptop return internet different temporarily recovery
      disconnect co-working space another city manager works Hours
      Availability responsibilities expected available responsive
      routinely contact non-urgent messages outside schedule required
      ogged accurately HyvidOne overtime requests leave changes leave
      Parity On-Site Employees remote statutory entitlements benefits 
      career opportunities treatment office permanently change payroll 
      government contributions requirements records accordingly tax
      technology monitor keyboard mouse headset webcam property
      purposes section securely lost stolen damaged negligence 
      stable connection power reimbursement arrangement writing
      issued returned condition working days ending requested
      failure value deducted final pay permitted law
    `,
    sectionBody: (
      <div className="space-y-4 text-sm  leading-relaxed">

        <div>
          <h3 className="text-sm font-bold title-text mb-1.5 flex items-center gap-2">
            <span className="w-2 h-2 rounded-full bg-emerald-500 inline-block" />
            2.1 How It Works
          </h3>

          <div className="pl-4 text-sm  leading-relaxed space-y-1.5">
            <p>All Hyvid Philippines employees work remotely by default. Your specific work location — whether your home or an agreed alternative — will be confirmed in your employment agreement.</p>
            <p>If you want to work from a different location temporarily (such as a co-working space or another city), check in with your manager first. You're welcome to do so as long as it doesn't affect your ability to meet your responsibilities or compromise data security.</p>
          </div>
        </div>

        <div>
          <h3 className="text-sm font-bold title-text mb-1.5 flex items-center gap-2">
            <span className="w-2 h-2 rounded-full bg-emerald-500 inline-block" />
            2.2 Your Hours and Availability
          </h3>

          <div className="pl-4 text-sm  leading-relaxed space-y-1.5">
            <p>Your working hours are set out in your employment agreement. Remote work doesn't change your hours, your entitlements, or your responsibilities — it just changes where you do your work.</p>
            <p>You're expected to be available and responsive during your agreed hours. Outside those hours, you have the right to disconnect. Hyvid will not routinely contact you after hours, and you're not required to respond to non-urgent messages outside your schedule.</p>
            <p>All time records must be logged accurately in HyvidOne, including overtime requests, leave, and any schedule changes.</p>
          </div>
        </div>

        <div>
          <h3 className="text-sm font-bold title-text mb-1.5 flex items-center gap-2">
            <span className="w-2 h-2 rounded-full bg-emerald-500 inline-block" />
            2.3 Parity with On-Site Employees
          </h3>

          <div className="pl-4 text-sm  leading-relaxed space-y-1.5">
            <p>Working remotely does not affect any of your statutory entitlements, benefits, leave, or career opportunities. You're entitled to the same treatment as you would receive working from an office. If you ever feel that's not the case, raise it with People &amp; Culture.</p>
          </div>
        </div>

        <div>
          <h3 className="text-sm font-bold title-text mb-1.5 flex items-center gap-2">
            <span className="w-2 h-2 rounded-full bg-emerald-500 inline-block" />
            2.4 Changes to Your Work Location
          </h3>

          <div className="pl-4 text-sm  leading-relaxed space-y-1.5">
            <p>If you want to permanently change your work location — for example, if you move to a different city — let People &amp; Culture know as soon as possible. This may affect payroll, tax, or government contribution requirements and we'll need to update your records accordingly.</p>
          </div>
        </div>

        <div>
          <h3 className="text-sm font-bold title-text mb-1.5 flex items-center gap-2">
            <span className="w-2 h-2 rounded-full bg-emerald-500 inline-block" />
            2.5 Equipment
          </h3>

          <div className="pl-4 text-sm  leading-relaxed space-y-1.5">
            <p>Hyvid will provide all technology required to perform your role. Before your start date, you will receive:</p>

            <ul className="list-none space-y-1.5 pl-2">
              <li className="flex items-start gap-2">
                <span className="mt-1.5 w-1.5 h-1.5 rounded-full bg-emerald-400 flex-shrink-0" />
                <span>A laptop</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="mt-1.5 w-1.5 h-1.5 rounded-full bg-emerald-400 flex-shrink-0" />
                <span>A monitor</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="mt-1.5 w-1.5 h-1.5 rounded-full bg-emerald-400 flex-shrink-0" />
                <span>A keyboard and mouse</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="mt-1.5 w-1.5 h-1.5 rounded-full bg-emerald-400 flex-shrink-0" />
                <span>A headset</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="mt-1.5 w-1.5 h-1.5 rounded-full bg-emerald-400 flex-shrink-0" />
                <span>A webcam</span>
              </li>
            </ul>

            <p>All equipment remains the property of Hyvid at all times. You are responsible for keeping it in good working order, storing it securely, and using it only for work purposes in accordance with Section 4 of this policy.</p>

            <p>If equipment is lost, stolen, or damaged, report it to People & Culture via HyvidOne immediately. Damage caused by negligence may result in cost recovery.</p>

            <p>You are responsible for maintaining a stable internet connection at your work location. Hyvid does not reimburse internet or power costs unless a specific arrangement has been agreed in writing with People &amp; Culture.</p>
        
         <div className="flex gap-3 p-3 rounded-lg border bg-amber-50 border-amber-200 dark:bg-amber-900/20 dark:border-amber-700"> <CircleAlert className="w-4 h-4 text-amber-500 flex-shrink-0 mt-0.5" />
            <div className="text-sm">
              All Hyvid-issued equipment must be returned in good condition within{" "}
              <strong>three (3) working days</strong> of your employment ending, or earlier if requested.
              Failure to return equipment may result in the value being deducted from your final pay to the extent permitted by law.
            </div>
          </div> 
         
          </div>
        </div>
      </div>
    ),
  },

  {
    sectionId: "data-privacy",
    sectionTitle: "3. Data Privacy",
    searchKeywords: `
      staffing personal data privacy act RA 10173 trust
      employee client third-party information handling
      responsible personal identify directly indirectly 
      names contact government ID financial health records
      sensitive beliefs background confidentiality collect 
      access use approved systems personal devices cloud 
      accounts unauthorised storage removal departure lost 
      breach report breaches accidentally unlawfully accessed
      altered disclosed potential discovery National Privacy 
      Commission seventy-two hours Protection Officer DPO 
      employment records payroll contributions processing 
      purpose obligations legal compliance sharing disclosure 
      correction access
    `,
    sectionBody: (
      <div className="space-y-4 text-sm  leading-relaxed">
        <div className="mb-4">
          <h3 className="text-sm font-bold title-text mb-1.5 flex items-center gap-2">
            <span className="w-2 h-2 rounded-full bg-emerald-500 inline-block" />
            3.1 Why This Matters
          </h3>

          <div className="pl-4 space-y-1.5">
            <p>
              As a staffing company, Hyvid handles personal data every day — employee information,
              client data, and the information of people our clients serve. The Data Privacy Act (RA 10173)
              requires us to handle all of this responsibly, and so does the trust of our clients.
            </p>

            <p>
              This section applies to any personal information you handle as part of your work, whether
              it belongs to a colleague, a client, or a third party.
            </p>
          </div>
        </div>

        <div className="mb-4">
          <h3 className="text-sm font-bold title-text mb-1.5 flex items-center gap-2">
            <span className="w-2 h-2 rounded-full bg-emerald-500 inline-block" />
            3.2 What Personal Data Means
          </h3>

          <div className="pl-4 space-y-1.5">
            <p>
              Personal data is any information that can identify a person, directly or indirectly.
              This includes names, contact details, government ID numbers, financial information,
              health records, and similar. It also includes sensitive personal information — like
              health data or information about someone's beliefs or background — which requires extra care.
            </p>
          </div>
        </div>

        <div className="mb-4">
          <h3 className="text-sm font-bold title-text mb-1.5 flex items-center gap-2">
            <span className="w-2 h-2 rounded-full bg-emerald-500 inline-block" />
            3.3 Your Obligations
          </h3>

          <ul className="list-none space-y-1.5 pl-2">
            <li className="flex items-start gap-2">
              <span className="mt-1.5 w-1.5 h-1.5 rounded-full bg-emerald-400 flex-shrink-0" />
              <span>Only collect, access, or use personal data when you need to for your work.</span>
            </li>

            <li className="flex items-start gap-2">
              <span className="mt-1.5 w-1.5 h-1.5 rounded-full bg-emerald-400 flex-shrink-0" />
              <span>Keep personal data confidential. Don't share it with anyone who doesn't need it.</span>
            </li>

            <li className="flex items-start gap-2">
              <span className="mt-1.5 w-1.5 h-1.5 rounded-full bg-emerald-400 flex-shrink-0" />
              <span>Don't store personal data on personal devices, personal cloud accounts, or anywhere outside Hyvid's approved systems.</span>
            </li>

            <li className="flex items-start gap-2">
              <span className="mt-1.5 w-1.5 h-1.5 rounded-full bg-emerald-400 flex-shrink-0" />
              <span>Don't take personal data with you when you leave Hyvid.</span>
            </li>

            <li className="flex items-start gap-2">
              <span className="mt-1.5 w-1.5 h-1.5 rounded-full bg-emerald-400 flex-shrink-0" />
              <span>
                If you think personal data has been lost, accessed without authorisation, or breached
                in any way, report it to People &amp; Culture immediately.
              </span>
            </li>
          </ul>
        </div>

        <div className="mb-4">
          <h3 className="text-sm font-bold title-text mb-1.5 flex items-center gap-2">
            <span className="w-2 h-2 rounded-full bg-emerald-500 inline-block" />
            3.4 Data Breaches
          </h3>

          <div className="pl-4 space-y-1.5">
            <p>
              A data breach is any situation where personal data is accidentally or unlawfully
              accessed, lost, altered, or disclosed. If you become aware of a potential breach —
              even if you're not sure — report it to People &amp; Culture straight away. Under RA 10173,
              serious breaches must be reported to the National Privacy Commission within 72 hours
              of discovery.
            </p>

            <div className="flex gap-3 p-3 rounded-lg border bg-blue-50 border-blue-200 dark:bg-blue-900/20 dark:border-blue-700">
              <Info className="w-4 h-4 text-blue-500 flex-shrink-0 mt-0.5" />

              <div className="text-sm">
                Hyvid's Data Protection Officer (DPO) can be contacted via HyvidOne.
              </div>
            </div>
          </div>
        </div>

        <div className="mb-4">
          <h3 className="text-sm font-bold title-text mb-1.5 flex items-center gap-2">
            <span className="w-2 h-2 rounded-full bg-emerald-500 inline-block" />
            3.5 Your Own Personal Data
          </h3>

          <div className="pl-4 space-y-1.5">
            <p>
              Hyvid collects and processes your personal data — such as your employment records,
              payroll information, and government contribution details — for the purpose of managing
              your employment. This is done in accordance with RA 10173. Your data will not be shared
              with third parties except as required by law or as necessary to fulfil Hyvid's obligations
              to clients.
            </p>

            <p>
              If you have questions about what data Hyvid holds about you, or you want to access or
              correct it, contact People &amp; Culture.
            </p>
          </div>
        </div>
      </div>
    ),
  },
  {
    sectionId: "it-use",
    sectionTitle: "4. IT and Technology Use",
    searchKeywords: `
      technology laptop phone internet email
      hyvidone platform tools devices acceptable
      productivity security illegal offensive discriminatory
      sexually explicit unauthorised software personal
      business third-party unsecured public wifi VPN
      credentials bypass tamper circumvent security
      harass stalk harm strong unique passwords multi-factor 
      authentication  MFA operating system browser updates
      screen lock cloud storage file-sharing google drive 
      dropbox lost stolen monitoring legitimate proportionate 
      compliance privacy notified nature purpose surveillance
      social media confidential reputation misleading
      statements personal views official accounts
      manager guidelines employment ends return
      delete handover retain copies revoked
    `,
    sectionBody: (
      <div className="space-y-4 text-sm  leading-relaxed">
        <div className="mb-4">
          <h3 className="text-sm font-bold title-text mb-1.5 flex items-center gap-2">
            <span className="w-2 h-2 rounded-full bg-emerald-500 inline-block" />
            4.1 What This Covers
          </h3>
          <div className="pl-4 text-sm  leading-relaxed space-y-1.5">
            <p>
              This section applies to all technology you use for work — whether it's Hyvid-issued or your own device. It includes your laptop, phone, internet connection, email, HyvidOne, and any other platform or tool you use in the course of your job.
            </p>
          </div>
        </div>

        <div className="mb-4">
          <h3 className="text-sm font-bold title-text mb-1.5 flex items-center gap-2">
            <span className="w-2 h-2 rounded-full bg-emerald-500 inline-block" />
            4.2 Acceptable Use
          </h3>
          <div className="pl-4 text-sm  leading-relaxed space-y-1.5">
            <p>
              Hyvid's systems and technology are provided for work. You may use them for work purposes, and reasonable personal use that doesn't affect your productivity or security is fine. What's not acceptable:
            </p>

            <ul className="list-none space-y-1.5 pl-2">
              {[
                "Accessing, storing, or sharing content that is illegal, offensive, discriminatory, or sexually explicit.",
                "Downloading or installing unauthorised software on Hyvid-issued devices.",
                "Using Hyvid systems to conduct personal business or to benefit a third party.",
                "Connecting to unsecured public Wi-Fi without a VPN when handling work data.",
                "Sharing your login credentials with anyone, including colleagues.",
                "Using another person's login credentials to access systems.",
                "Attempting to bypass, tamper with, or circumvent any security measure.",
                "Using Hyvid systems to harass, stalk, or harm another person.",
              ].map((item) => (
                <li key={item} className="flex items-start gap-2">
                  <span className="mt-1.5 w-1.5 h-1.5 rounded-full bg-emerald-400 flex-shrink-0" />
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mb-4">
          <h3 className="text-sm font-bold title-text mb-1.5 flex items-center gap-2">
            <span className="w-2 h-2 rounded-full bg-emerald-500 inline-block" />
            4.3 Security Requirements
          </h3>

          <div className="pl-4 text-sm  leading-relaxed space-y-1.5">
            <p>To protect Hyvid's systems and client data, you must:</p>

            <div className="grid sm:grid-cols-2 gap-2 mt-2">
              <div className="flex items-start gap-2 p-2.5 rounded-lg dark-mode-card border border-gray-100">
                <Lock className="w-3.5 h-3.5 text-purple-500 flex-shrink-0 mt-0.5" />
                <p className="text-xs ">
                  Use strong, unique passwords for all work accounts and change them when asked.
                </p>
              </div>

              <div className="flex items-start gap-2 p-2.5 rounded-lg dark-mode-card border border-gray-100">
                <ShieldCheck className="w-3.5 h-3.5 text-emerald-500 flex-shrink-0 mt-0.5" />
                <p className="text-xs ">
                  Enable multi-factor authentication (MFA) on all accounts where it is available.
                </p>
              </div>

              <div className="flex items-start gap-2 p-2.5 rounded-lg dark-mode-card border border-gray-100">
                <Monitor className="w-3.5 h-3.5 text-blue-500 flex-shrink-0 mt-0.5" />
                <p className="text-xs ">
                  Keep your operating system, browser, and software up to date.
                </p>
              </div>

              <div className="flex items-start gap-2 p-2.5 rounded-lg dark-mode-card border border-gray-100">
                <Monitor className="w-3.5 h-3.5 text-orange-500 flex-shrink-0 mt-0.5" />
                <p className="text-xs ">
                  Lock your screen when you step away from your device, even at home.
                </p>
              </div>

              <div className="flex items-start gap-2 p-2.5 rounded-lg dark-mode-card border border-gray-100">
                <Wifi className="w-3.5 h-3.5 text-teal-500 flex-shrink-0 mt-0.5" />
                <p className="text-xs ">
                  Use only Hyvid-approved cloud storage and file-sharing tools. Don't use personal Google Drive, Dropbox, or similar services for work files.
                </p>
              </div>

              <div className="flex items-start gap-2 p-2.5 rounded-lg dark-mode-card border border-gray-100">
                <CircleAlert className="w-3.5 h-3.5 text-red-500 flex-shrink-0 mt-0.5" />
                <p className="text-xs ">
                  Report any lost or stolen device to People &amp; Culture immediately.
                </p>
              </div>

              <div className="flex items-start gap-2 p-2.5 rounded-lg dark-mode-card border border-gray-100">
                <ShieldCheck className="w-3.5 h-3.5 text-indigo-500 flex-shrink-0 mt-0.5" />
                <p className="text-xs ">
                  Use a VPN when instructed to do so by Hyvid.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="mb-4">
          <h3 className="text-sm font-bold title-text mb-1.5 flex items-center gap-2">
            <span className="w-2 h-2 rounded-full bg-emerald-500 inline-block" />
            4.4 Monitoring
          </h3>

          <div className="pl-4 text-sm  leading-relaxed space-y-1.5">
            <p>
              Hyvid may monitor activity on company-issued devices and systems for legitimate business and security purposes. Where monitoring takes place, it will be proportionate, focused on work activity, and conducted in compliance with the Data Privacy Act. You will be notified of the nature and purpose of any monitoring tools in use.
            </p>

            <div className="flex gap-3 p-3 rounded-lg border bg-emerald-50 border-emerald-200 dark:bg-emerald-900/20 dark:border-emerald-700">
              <CircleCheckBig className="w-4 h-4 text-emerald-500 flex-shrink-0 mt-0.5" />
              <div className="text-sm">
                Monitoring is not used to track personal activity or to surveil employees outside of working hours.
              </div>
            </div>
          </div>
        </div>

        <div className="mb-4">
          <h3 className="text-sm font-bold title-text mb-1.5 flex items-center gap-2">
            <span className="w-2 h-2 rounded-full bg-emerald-500 inline-block" />
            4.5 Social Media
          </h3>

          <div className="pl-4 text-sm  leading-relaxed space-y-1.5">
            <p>You're free to use social media in your personal time. When you do, please:</p>

            <ul className="list-none space-y-1.5 pl-2">
              {[
                "Don't share confidential information about Hyvid, our clients, or your colleagues.",
                "Don't make statements that could damage Hyvid's reputation or mislead others about our services.",
                "Make clear that personal views expressed online are your own and not Hyvid's.",
              ].map((item) => (
                <li key={item} className="flex items-start gap-2">
                  <span className="mt-1.5 w-1.5 h-1.5 rounded-full bg-emerald-400 flex-shrink-0" />
                  <span>{item}</span>
                </li>
              ))}
            </ul>

            <p>
              If you manage or contribute to Hyvid's official social media accounts as part of your role, follow any additional guidelines provided by your manager.
            </p>
          </div>
        </div>

        <div className="mb-4">
          <h3 className="text-sm font-bold title-text mb-1.5 flex items-center gap-2">
            <span className="w-2 h-2 rounded-full bg-emerald-500 inline-block" />
            4.6 Leaving Hyvid
          </h3>

          <div className="pl-4 text-sm  leading-relaxed space-y-1.5">
            <p>When your employment ends, you must:</p>

            <ul className="list-none space-y-1.5 pl-2">
              {[
                "Return all Hyvid-issued equipment promptly.",
                "Delete or hand over all work files, emails, and data on personal devices.",
                "Not retain copies of any confidential or personal data.",
              ].map((item) => (
                <li key={item} className="flex items-start gap-2">
                  <span className="mt-1.5 w-1.5 h-1.5 rounded-full bg-emerald-400 flex-shrink-0" />
                  <span>{item}</span>
                </li>
              ))}
            </ul>

            <div className="flex gap-3 p-3 rounded-lg border bg-amber-50 border-amber-200 dark:bg-amber-900/20 dark:border-amber-700">
              <CircleAlert className="w-4 h-4 text-amber-500 flex-shrink-0 mt-0.5" />
              <div className="text-sm">
                Access to Hyvid systems will be revoked on your last day of employment.
              </div>
            </div>
          </div>
        </div>
      </div>
    ),
  },

  {
    sectionId: "consequences",
    sectionTitle: "5. Consequences of Breaching This Policy",
    searchKeywords: `
      breaches policy remote conduct data handling
      misuse technology disciplinary dismissal
      serious client deliberate misconduct legal action
      disciplinary framework handbook classification offenses
      penalties privacy act RA10173 fines
      5 million imprisonment negligent intentional mishandling
      national commission
    `,
    sectionBody: (
      <div className="space-y-4 text-sm  leading-relaxed">
        <p>
          Breaches of this policy — whether related to remote work conduct, data handling, or misuse of technology — are serious matters. Depending on the circumstances, a breach may result in disciplinary action up to and including dismissal. Serious breaches involving client data or deliberate misconduct may also result in legal action.
        </p>

        <p>
          Refer to Hyvid's disciplinary framework in the Employee Handbook for the full classification of offenses.
        </p>

        <div className="flex gap-3 p-3 rounded-lg border bg-red-50 border-red-200 dark:bg-red-900/20 dark:border-red-700">
          <CircleAlert className="w-4 h-4 text-red-500 flex-shrink-0 mt-0.5" />
          <div className="text-sm">
            <p className="font-semibold mb-1 text-red-800 dark:text-red-100">
              Penalties under the Data Privacy Act
            </p>
            Violations of RA 10173 can result in fines of up to <strong>PHP 5 million</strong> and/or imprisonment. Negligent or intentional mishandling of personal data is taken very seriously, by both Hyvid and the National Privacy Commission.
          </div>
        </div>
      </div>
    ),
  },
  {
    sectionId: "questions",
    sectionTitle: "6. Questions",
    searchKeywords: `
      unsure allowed technology remote
      arrangements ask people culture
      contact protection officer hyvidone
      privacy questions legal references
      telecommuting act RA11165 DOLE
      department order 237-22
      data privacy 2012 RA10173
    `,
    sectionBody: (
      <div className="space-y-4 text-sm  leading-relaxed">
        <p>
          If you're ever unsure about whether something is allowed — whether it's a data question, a technology question, or a question about remote work arrangements — ask People &amp; Culture before doing it. It's always better to check.
        </p>

        <p>
          You can also contact Hyvid's Data Protection Officer via HyvidOne for data privacy-specific questions.
        </p>
        <div className="mt-8 p-4 bg-gray-100 dark:bg-gray-900/20 rounded-xl border border-gray-200 dark:border-gray-700">
          <p className="text-xs muted-text italic">
            <strong>Legal references:</strong> 
            Telecommuting Act (RA 11165), DOLE Department Order No. 237-22, Data Privacy Act of 2012 (RA 10173).
          </p>
        </div>
      </div>
    ),
  },
];

const DataPrivacyContents = ({ searchTerm }) => {
  const filteredSections = sections.filter((section) => {
    if (!searchTerm) return true;
    
    const search = searchTerm.toLowerCase();
    
    return (
      section.sectionTitle.toLowerCase().includes(search) ||
      section.searchKeywords?.toLowerCase().includes(search)
    );
  });

  return (
    <ContentsContainer sections={filteredSections} />
  );
};

export default DataPrivacyContents;